import { types, getRoot  } from "mobx-state-tree"
import User from "../../models/user/User"
import differenceBy from 'lodash/differenceBy'
import intersectionBy from 'lodash/intersectionBy'
import filter from 'lodash/filter'
import find from 'lodash/find'
import map from 'lodash/map'
import { api_get_users } from '../../../queries/users'
import { toJS } from "mobx"

const UsersFactory = types
  .model('UsersFactory', {
    users: types.optional(
      types.array(User), []
    )
  })
  .views(self => ({
    get merchantsFactory() {
      return getRoot(self).merchantsFactory
    },
    get locationsFactory() {
      return getRoot(self).locationsFactory
    },
    get paymentMethodsFactory() {
      return getRoot(self).paymentMethodsFactory
    },

  }))
  .actions(self => ({
    addUpdateUsers(u) {
      const users = self.parseUsers(u)
      const add = differenceBy(users, self.users, 'id')
      const update = intersectionBy(self.users, users, 'id')
      map(update, u => u.update(
        filter(users, usr => usr.id === u.id)[0]
      ))
      self.users.push(...add)
      return map(users, a => a.id)
    },
    addUpdateUser(user, string) {
      const ids = self.addUpdateUsers([user])
      return ids[0]
    },
    getUser(id) {
      return find(self.users, u => u.id === id)
    },
    parseUsers(usrs) {
      return map(usrs, u => ({
          ...u,
          managingStore: u.managingStore?.id ? self.merchantsFactory.addUpdateMerchant(u.managingStore) : null,
          merchant: u.merchant?.id ? self.merchantsFactory.addUpdateMerchant(u.merchant) : null,
          //location: u.location?.id ? self.locationsFactory.addUpdateLocation(u.location) : null,
          locations: Array.isArray(u.locations) && u.locations.length ? self.locationsFactory.addUpdateLocations(u.locations) : null,
          paymentMethods: Array.isArray(u.paymentMethods) && u.paymentMethods.length ? self.paymentMethodsFactory.addUpdatePaymentMethods(u.paymentMethods) : null,
      }))
    },
    async fetchUsers(token) {
      try {
        const res = await api_get_users(token)
        if (res.error) throw res
        
        self.addUpdateUsers(res.data)

        return res.data
      } catch (err) {
        return err
      }
    },
    set(key, value) {
      self[key] = value
    }
  }))

export default UsersFactory